import { ErrorReporterArgumentType } from "../../domain/interfaces/error-reporter-argument-type";
import { IErrorReporter } from "../../domain/interfaces/error-reporter.interface";

export class NullErrorReporter implements IErrorReporter {
	public critical(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

	public debug(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

	public error(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

	public info(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

	public log(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

	public warn(...args: ErrorReporterArgumentType[]): void {
		// Placeholder
	}

}
